module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"account":"Личный кабинет","logout":"Выход","partners":"Партнёры","news":"Новости","directory":"Справочная","services":"Услуги","bulletin_board":"Объявления","another":"Другое"},"uk":{"account":"Особистий кабінет","logout":"Вихід","partners":"Партнери","news":"Новини","directory":"Довідкова","services":"Послуги","bulletin_board":"Оголошення","another":"Інше"}}')
  delete Component.options._Ctor
}
